/* global maksimer_params */
/* global woocommerce_params */
/* global gtm4wp_currency */
/* global gtm4wp_datalayer_name */
jQuery(($) => {
	let colorAttrId = 0;
	let subAttrId = 0;
	let selectedVariation = 0;
	let prodId = 0;
	let productPrice = 0;
	let totalPriceSelected = 0;
	let priceProduct = 0;
	let priceContract = 0;
	let priceWarranty = 0;
	const shippingPrice = 89;
	const priceHTML = $(".woocommerce-Price-currencySymbol").first().html();
	const bundleWrap = $(".bundle_form .bundle_data");
	const currencySymbol = "DKK";

	function qtyUpDownInit() {
		$(".quantity").each(function () {
			const qtyWrapper = $(this);
			const qtyInput = qtyWrapper.find('input[type="number"]');
			const btnUp = qtyWrapper.find(".qty-up");
			const btnDown = qtyWrapper.find(".qty-down");
			const minQty = qtyInput.attr("min");
			let maxQty = qtyInput.attr("max");
			const step = qtyInput.attr("step")
				? parseFloat(qtyInput.attr("step"))
				: 1;

			if (maxQty === "") {
				maxQty = 9999;
			}

			btnUp.click(() => {
				const oldValue = qtyInput.val() ? parseFloat(qtyInput.val()) : 0;
				let newValUp;

				if (oldValue + step > maxQty) {
					newValUp = oldValue;
				} else {
					newValUp = oldValue + step;
				}

				console.log(newValUp);

				qtyWrapper.find("input").val(newValUp);
				qtyWrapper.find("input").trigger("change");
				$("[name='update_cart']").trigger("click");
			});

			btnDown.click(() => {
				const oldValue = qtyInput.val() ? parseFloat(qtyInput.val()) : 0;
				let newValDown;

				if (oldValue - step < minQty) {
					newValDown = oldValue;
				} else {
					newValDown = oldValue - step;
				}

				qtyWrapper.find("input").val(newValDown);
				qtyWrapper.find("input").trigger("change");
				$("[name='update_cart']").trigger("click");

				console.log("OK test btnDown");
			});
		});
	}

	function sumPrices() {
		const colorRow = $("tr#summary-watch");
		const subscriptionRow = $("tr#summary-subscription");
		const garantiRow = $("tr#summary-garanti");
		const summaryRow = $("tr#summary-total");
		let colorString;
		let colorPriceString;
		let subscriptionString;
		let subscriptionPriceString;

		if ($("a.product-color-image.selected").length > 0) {
			colorString = $("a.product-color-image.selected")
				.closest(".bundled_item_cart_content")
				.data("product_title");
			colorPriceString = `${$("a.product-color-image.selected").data(
				"variation-price"
			)} ${$("a.product-color-image.selected").data("currency")}`;
			colorRow.find("th").html(colorString);
			colorRow.find("td").html(colorPriceString);
		} else {
			colorRow.find("th, tr").html("");
		}

		if ($(".offer.selected").length > 0) {
			subscriptionString = $(".offer.selected").data("name");
			subscriptionPriceString = $(".offer.selected").data("cost");
			subscriptionRow.find("th").html(subscriptionString);
			subscriptionRow.find("td").html(subscriptionPriceString.replace("+", ""));
		} else {
			subscriptionRow.find("th, tr").html("");
		}

		// Not the best way to grab garanti, but it will work for now
		if (
			$(".bundled_item_3 input.bundled_product_checkbox:checked").length > 0 ||
			$(".bundled_item_8 input.bundled_product_checkbox:checked").length > 0 ||
			$(".bundled_item_18 input.bundled_product_checkbox:checked").length > 0 ||
			$(".bundled_item_54 input.bundled_product_checkbox:checked").length > 0 ||
			$(".bundled_item_80 input.bundled_product_checkbox:checked").length > 0
		) {
			garantiRow
				.find("th")
				.html(
					"Tilføj garanti ved knust glas*, kr. 29,- pr. mnd., forudbetales for 1 år"
				);
			garantiRow.find("td").html(`348 ${currencySymbol}`);
		} else {
			garantiRow.find("th, tr").html("");
			garantiRow.find("td").html("");
		}

		summaryRow.find("td:last-child").html($(".bundle_wrap .bundle_price .price").html());

		// Show summary if color or sub are picked, hide otherwise
		if (
			$("a.product-color-image.selected").length > 0 &&
			$(".offer.selected").length > 0
		) {
			subscriptionRow.show();
			colorRow.show();
			garantiRow.show();
			summaryRow.show();
		} else {
			subscriptionRow.hide();
			colorRow.hide();
			garantiRow.hide();
			summaryRow.hide();
		}

		if ($("a.product-color-image").hasClass("selected")) {
			priceProduct = $("a.product-color-image.selected").data(
				"variation-price"
			);
		}

		if ($(".offer").hasClass("selected")) {
			priceContract = $(".offer.selected").data("total-cost");
		}

		if ($(".warrenty-section").hasClass("selected")) {
			priceWarranty = $(".warrenty-section.selected").data("warranty-price");
		}

		let priceCrossSum = 0;
		$(".cross-product.selected").each(function () {
			const priceCross = $(this).data("crossprice");
			priceCrossSum += priceCross;
		});

		totalPriceSelected =
			priceProduct + priceContract + priceWarranty + priceCrossSum;

		$("#offer-total").text(`${totalPriceSelected} kr`);
	}

	$(document).ready(() => {
		prodId = $("#product-id").val();

		// Move things around on mobile in product page.
		if ($(window).width() < 551) {
			$(
				".woocommerce-product-details__short-description, #product-read-more-wrapper, klarna-placement"
			).appendTo("#mobile-text-section");

			if ($("#color-section").length > 0) {
				$(
					'<span id="watch-tagline">Barnets første mobiltelefon</span>'
				).insertAfter(".product_title");
			}
		}

		bundleWrap.on("woocommerce-product-bundle-updated-totals", () => {
			sumPrices();
		});

		// If there's only one color option, select it.
		if ($("ul#colors li").length === 1) {
			$("ul#colors li a.product-color-image").addClass("selected");
			$("#step-1").addClass("checked");

			colorAttrId = $("a.product-color-image.selected").data("color-attr-id");
			productPrice = $("a.product-color-image.selected").data(
				"variation-price"
			);

			console.log(productPrice);

			$(".choose-subscription").removeClass("inactive");
		}

		$(".bundled_table_item .product-thumbnail img").each(function () {
			const bundledWrapper = $(this).closest(".bundled_table_item");
			const bundleWrapper = bundledWrapper.prev();
			// console.log(bundleWrapper);
			bundleWrapper.find(".product-thumbnail").html($(this).parent().html());
		});
	});

	// Garanti toggle.
	$(
		".bundled_item_3 input.bundled_product_checkbox, .bundled_item_8 input.bundled_product_checkbox, .bundled_item_18 input.bundled_product_checkbox"
	).change(() => {
		console.log("change");
		sumPrices();
	});

	$(document).on("click", "#bundle-subscriptions .offer-header", function (e) {
		e.preventDefault();
		$("#bundle-subscriptions .offer").removeClass("selected");
		$(this).parent().addClass("selected");
	});

	// Move garanti bundled item next to buy button.
	$(document).ready(() => {
		$("#bundle-config .bundled_item_optional .product_excerpt").remove();
		$("#bundle-config .bundled_item_optional").prependTo(
			"#bundle-summary .bundle_button"
		);
	});

	// Hide/show product summary for bundles.
	$(".bundle_wrap").on("woocommerce-product-bundle-show", () => {
		$("#bundle-selection-summary").show();
		$("#bundle-summary .bundled_product").show();
	});
	$(".bundle_wrap").on("woocommerce-product-bundle-hide", () => {
		$("#bundle-selection-summary").hide();
		$("#bundle-summary .bundled_product").hide();
	});

	/**
	 * Chooses watch color.
	 *
	 * This function needs to do following:
	 *
	 * - Set selected color variable
	 * - Scroll down to subscription section
	 *
	 * @param scroll
	 */
	const setActiveColor = function (el) {
		$("a.product-color-image").removeClass("selected");
		$(el).addClass("selected");

		$("#step-1").addClass("checked");
		$(".yes-step").css("display", "flex");
		$(".summary-details-phone").css("display", "flex");
		if (
			$(".yes-step-two").css("display") === "flex" &&
			$(".yes-step").css("display") === "flex"
		) {
			$(".choose-subscription").removeClass("inactive");
		}
		sumPrices();

		colorAttrId = $("a.product-color-image.selected").data("color-attr-id");
		productPrice = $("a.product-color-image.selected").data("variation-price");

		$("#color-phone").text(
			"".concat($(".product-color-image.selected").data("color-name"), "")
		);
		$("#price-phone").text(
			"".concat($(".product-color-image.selected").data("variation-price"), "")
		);

		$(".choose-subscription").removeClass("inactive");

		$(el)
			.closest(".bundled_product")
			.find(".variations select")
			.val($(el).data("color"))
			.trigger("change");

		// Scroll to subscription chooser.
		// $('html, body').animate({
		//   scrollTop: $('#subscription-section').offset().top,
		// }, 800);
	};

	const appendWatchToCartSummary = function (data) {
		$("#product-not-configured").hide();
		$("#summary-section").removeClass("not-ready");
		$("#add-more-watches").show();

		// Reset selected color.
		$(".product-color-image").removeClass("selected");
		$(".choose-subscription").addClass("inactive");

		$("#step-2").addClass("checked");

		$("#cart-summary #new-products").append(data.output);
	};

	const addWatchToCart = function () {
		const selectedOffer = $(".offer.selected");

		const crossProducts = [];
		let hasGaranti = "no";
		if ($("input[name=garanti-]").is(":checked")) {
			hasGaranti = "yes";
		}

		$(".cross-product.selected").each(function () {
			crossProducts.push($(this).data("crossid"));
		});
		console.log(crossProducts);
		console.log(`garanti${hasGaranti}`);

		subAttrId = selectedOffer.data("subscription-id");

		selectedVariation = $(
			`.variation-info[data-color-attr-id="${colorAttrId}"][data-sub-attr-id="${subAttrId}"]`
		).data("varid");

		// NOW ADD IT TO CART
		$.ajax({
			type: "POST",
			url: maksimer_params.add_to_cart_url,
			data: {
				product: prodId,
				variation: selectedVariation,
				garanti: hasGaranti,
				crossproducts: crossProducts,
				nonce: maksimer_params.add_to_cart_nonce,
			},
			dataType: "json",
			success(response) {
				if (response.success) {
					console.log(response.data);
					// Push event to dataLayer so it can be used as trigger in Google Tag Manager.
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: "watch-added-to-cart",
						garanti: hasGaranti,
						watch: $("h1.product_title").text(),
						color: $("a.product-color-image.selected").data("color-name"),
						subscription: selectedOffer.data("subscription"),
						product_name: response.data.product_name,
						product_price: response.data.product_price,
						product_sku: response.data.product_sku,
					});

					// Do what GTM4WP would normally do.
					window[gtm4wp_datalayer_name].push({
						event: "gtm4wp.addProductToCartEEC",
						ecommerce: {
							currencyCode: gtm4wp_currency,
							add: {
								products: response.data.products_in_cart,
							},
						},
					});

					// console.log(response);
					appendWatchToCartSummary(response.data);

					$(".choose-subscription").unblock();

					// $('html, body').animate({ scrollTop: 0 }, 300);
					// window.location.reload();
					const cartUrl = $(".choose-subscription").data("redirect");
					window.location.replace(cartUrl);
				} else {
					// console.log(response);
				}
			},
			error() {
				// console.log(response);
			},
			complete() {
				// console.log(data);
			},
		});
	};

	const removeProductFromCart = function (cartKey) {
		const parentTable = $(`#remove-${cartKey}`).closest("table");

		// NOW ADD IT TO CART
		$.ajax({
			type: "POST",
			url: maksimer_params.remove_from_cart_url,
			data: {
				cart_item_key: cartKey,
				nonce: maksimer_params.remove_from_cart_nonce,
			},
			dataType: "json",
			success(response) {
				if (response.success) {
					// console.log(response);
					// Remove row
					parentTable.fadeOut(300, () => {
						parentTable.remove();
					});
				} else {
					// console.log(response);
				}
			},
			error() {
				// console.log(response);
			},
			complete() {
				// console.log(data);
			},
		});
	};

	// Remove product from cart
	$(document).on("click", ".remove-product", function (e) {
		const removeCartKey = $(this).data("cart-key");

		e.preventDefault();

		$(this)
			.closest("table")
			.block({
				message: null,
				overlayCSS: {
					background: "#fff",
					opacity: 0.6,
				},
			});

		removeProductFromCart(removeCartKey);
	});

	// Add more watches reset
	$(document).on("click", "#add-more-watches", (e) => {
		e.preventDefault();

		$("#add-more-watches").hide();

		// Open 12m offer again.
		$("#offers .offer").removeClass("selected").first().addClass("selected");

		// Scroll to subscription chooser.
		$("html, body").animate(
			{
				scrollTop: $("#color-section").offset().top,
			},
			800
		);
	});

	$(document).ready(() => {
		$("#shipping-price").html(`${priceHTML} ${shippingPrice}`);
	});

	// Disable this in prep for redesign launch 02.23
	/* $(document).on("click", ".menu-item-has-children > a", function (e) {
		e.preventDefault();
		$(this).parent().find(".sub-menu").toggle();
	}); */

	$(document).on("click", "#mini-cart #header-buy-now", (e) => {
		// Make Buy now button in mobile header scroll down to buy section when viewing product page.
		if (
			$("body").hasClass("single-product") &&
			$("h1.product_title").html() === "XPLORA 3S"
		) {
			e.preventDefault();

			const topValue = $("#color-section").offset().top;

			$("html, body").animate({ scrollTop: topValue - 45 }, 600);
		}
	});

	// Mini-cart.
	$(document).on("click", ".mini-cart-toggle", function () {
		$(".mini-cart-wrapper").show();
		$(this).hide();
	});

	$(document).on("click", "#close-mini-cart", (e) => {
		e.preventDefault();
		$(".mini-cart-wrapper").hide();
		$(".mini-cart-toggle").show();
	});

	// $('#offers .offer').first().addClass('selected');

	$(document).on("click", ".menu-toggle > a", (e) => {
		e.preventDefault();
		const body = $("body");

		$(body).toggleClass("open-fullscreen-menu");
	});

	$(document).on("click", "#coupon-toggle > a", (e) => {
		e.preventDefault();
		$("#coupon-toggle").hide();
		$("#coupon-wrapper").show();
	});

	$(document).on("click", "a.product-color-image", function (e) {
		e.preventDefault();
		setActiveColor(this);

		$("div.bundled_product_summary").addClass("open");
		$("div.bundled_product_summary").show();
		$("div.bundled_product_summary .subscription-overlay").hide();
	});

	// $('#offers .offer').first().addClass('selected');

	$(document).on("click", "#offers .offer-header", function (e) {
		e.preventDefault();
		$("#offers .offer").removeClass("selected");
		$(this).parent().addClass("selected");
		$(".yes-step-two").css("display", "flex");
		const selectedContract = $(".offer.selected");
		$("#subscription-length").text(selectedContract.data("duration-label"));

		const selectedSubscription = selectedContract.data("total-cost");
		if (selectedSubscription !== 0) {
			$("#subscription-price").text(`${selectedContract.data("total-cost")}`);
			$("#subscription-price-symbol").text(" kr");
		} else {
			$("#subscription-price").text(`${selectedContract.data("costPer")}`);
			$("#subscription-price-symbol").text(
				` / ${selectedContract.data("period")}`
			);
		}

		if (
			$(".yes-step-two").css("display") === "flex" &&
			$(".yes-step").css("display") === "flex"
		) {
			$(".choose-subscription").removeClass("inactive");
		}

		// Dynamically change bundle select element value.
		$(this)
			.closest(".bundled_product")
			.find(".variations select")
			.val($(this).parent().data("subscription"))
			.trigger("change");

		console.log($(this).parent().data("subscription"));

		sumPrices();
	});

	$(document).on(
		"click",
		"#new-summary-section .offer-summary .info .choose-subscription",
		function (e) {
			e.preventDefault();

			if (!$(this).hasClass("inactive")) {
				$(this).block({
					message: null,
					overlayCSS: {
						background: "#fff",
						opacity: 0.6,
					},
				});

				if (!$(this).hasClass("inactive")) {
					addWatchToCart();
				}
			}
		}
	);

	$(document).on(
		"click",
		".bundle-subscription .choose-subscription",
		function (e) {
			e.preventDefault();

			if (!$(this).hasClass("inactive")) {
				// addWatchToCart();

				$(this).parent().parent().find('input[type="radio"]').trigger("click");

				// Scroll to subscription chooser.
				$("html, body").animate(
					{
						scrollTop: $("#bundle-summary").offset().top,
					},
					800
				);
			}
		}
	);

	// Accordion.
	$(document).on("click", ".accordion-title:not(.open)", function () {
		$(".accordion-title").removeClass("open");
		$(this).addClass("open");

		$(".accordion-content").slideUp();
		$(this).parent().find(".accordion-content").slideDown();
	});

	$(document).on("click", ".accordion-title.open", function () {
		$(this).removeClass("open");
		$(this).parent().find(".accordion-content").slideUp();
	});

	// Read more click.
	$(document).on("click", "#product-read-more", (e) => {
		e.preventDefault();

		$(".accordion-title").removeClass("open");
		$(".accordion-content").hide();
		$(".functions-section h4").addClass("open");
		$(".functions-section .accordion-content").show();

		const topValue = $("#product-accordion").offset().top;

		$("html, body").animate({ scrollTop: topValue }, 600);
	});

	// Reviews link click.
	$(document).on("click", ".single-product .woocommerce-review-link", (e) => {
		e.preventDefault();

		$(".accordion-title").removeClass("open");
		$(".accordion-content").hide();
		$(".reviews-section h4").addClass("open");
		$(".reviews-section .accordion-content").show();

		const topValue = $("#product-accordion").offset().top;

		$("html, body").animate({ scrollTop: topValue }, 600);
	});

	qtyUpDownInit();

	$(document.body).on("updated_cart_totals", () => {
		qtyUpDownInit();
	});

	$(document).on("click", ".watch-img", function () {
		// jQuery('.watch-img').click(function () {
		jQuery(this)
			.parent()
			.parent()
			.find('input[type="checkbox"]')
			.trigger("click");
	});

	jQuery(".garanti-btn").click((e) => {
		e.preventDefault();

		const $self = $(this);

		$self.hide();

		if (!$("#billing_email").val() || !$("#order_number").val()) {
			$(".form-messages").html("Billing name and email fields are required.");
			return;
		}

		const data = {
			action: "garanti_form",
			billing_email: $("#billing_email").val(),
			order_number: $("#order_number").val(),
			nonce: $("#garanti-search-nonce").val(),
		};

		$(".form-messages").html("Please wait while we check your order...");

		$("#billing_email").prop("disabled", true);
		$("#order_number").prop("disabled", true);

		$.post(woocommerce_params.ajax_url, data, (response) => {
			$("#billing_email").prop("disabled", false);
			$("#order_number").prop("disabled", false);

			$(".form-messages").html("");

			if (response.error === true) {
				$(".form-messages").html(response.error_message);
			} else {
				$(".garanti-wrapper").html(response.product_output);
			}
		});
	});

	jQuery(".garanti-imei-btn").click((e) => {
		e.preventDefault();

		if (!$("#imei-1").val()) {
			$(".form-messages").html(
				"Fyll inn XPLORA telefonens IMEI nr (du finner det i innstillinger)"
			);
			return;
		}

		if (!/^\d+$/.test($("#imei-1").val())) {
			$(".form-messages").html("Feil format: IMEI skal bare være sifre.");
			return;
		}

		if ($("#imei-1").val().length < 15) {
			$(".form-messages").html("Feil format: IMEI skal være 15 siffer.");
			return;
		}

		const data = {
			action: "garanti_imei_form",
			imei_1: $("#imei-1").val(),
			imei_2: $("#imei-2").val(),
			imei_3: $("#imei-3").val(),
			nonce: $("#garanti-imei-nonce").val(),
		};

		// $('.form-messages').html('Please wait while we check your order...');

		$("#imei").prop("disabled", true);

		$.post(woocommerce_params.ajax_url, data, (response) => {
			$("#imei").prop("disabled", false);

			$(".form-messages").html("");

			if (response.error === true) {
				console.log("error ajax");
				$(".form-messages").html(
					"Fyll inn XPLORA telefonens IMEI nr (du finner det i innstillinger)"
				);
			} else if (response.success) {
				console.log("success ajax");
				console.log(response);
				window.location.href = response.data.redirect;
			} else {
				console.log("response.success false");
				console.log(response);
			}
		});
	});

	$(document).ready(() => {
		$("#imei-add-more").click((e) => {
			e.preventDefault();

			if (!$("#imei-1").val()) {
				$(".form-messages").html(
					"Fyll inn XPLORA telefonens IMEI nr (du finner det i innstillinger)"
				);
				return;
			}

			$("#more-imei").show();
		});
	});

	$(document).on("click", ".bundle-watch", () => {
		$(".choose-subscription").removeClass("inactive");
	});

	$("input[name=garanti-]").change(function () {
		if ($(this).is(":checked")) {
			$(".warrenty-section").addClass("selected");
			$(".summary-details-warranty").css("display", "flex");
		} else {
			$(".warrenty-section").removeClass("selected");
			$(".summary-details-warranty").css("display", "none");
			priceWarranty = 0;
		}
		sumPrices();
	});

	$(".cross-checkbox").change(function () {
		if ($(this).is(":checked")) {
			$(`#cross-${$(this).data("crossid")}`).css("display", "flex");
			$(`.cross-${$(this).data("crossid")}`).addClass("selected");
		} else {
			$(`#cross-${$(this).data("crossid")}`).css("display", "none");
			$(`.cross-${$(this).data("crossid")}`).removeClass("selected");
		}
		sumPrices();
	});

	// Comparison table
	$(document).on("click", ".comparison-section", function () {
		if ($(".comparison-table").hasClass("open")) {
			$(".comparison-header svg").removeClass("open");
			$(".comparison-table").removeClass("open");
		} else {
			$(".comparison-header svg").addClass("open");
			$(".comparison-table").addClass("open");
		}
	});
});

document.addEventListener("DOMContentLoaded", listenForNoSim, false);
function listenForNoSim() {
	const nosimSelector = document.querySelector(".nosim-parent-selector");
	if (nosimSelector !== null) {
		const nosimContainer = document.querySelector(".nosim-parent-container");

		nosimSelector.addEventListener("click", function (e) {
			nosimContainer.classList.toggle("open");
		});
	}
}
